import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {hexToRgb, isPositiveInteger, rgbToHex} from '../utils/General';
import Input from "../components-new/form/Input";
import DropdownSelect from "../components-new/form/DropdownSelect";
import './ColorInput.css';


const RGB = 'RGB';
const HEX = 'HEX';
const DEBOUNCE_TIME = 500;

/*
 * Whatever is stored, the picker has to open. hexToRgb matches six digits
 * exactly and returns null for anything else, so a value that is longer is
 * read as its first six digits, and one that makes no sense at all as black.
 */
const parseColor = value => hexToRgb(String(value || '').slice(0, 7)) || {r: 0, g: 0, b: 0};

const swatchColor = value => String(value || '').slice(0, 7) || '#000000';

const colorOptions = [
    {
        title: HEX,
        value: HEX,
    },
    {
        title: RGB,
        value: RGB,
    },
];


class ColorInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mod: {
                title: RGB,
                value: RGB,
            },
            tempColor: props.value,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({tempColor: this.props.value});
        }
    }

    changeMod = (value) => {
        this.setState({
            mod: value,
        });
    };

    handleColorChange = (e) => {
        this.setState({tempColor: e.target.value});
    };

    handleColorBlur = () => {
        const {handleChange} = this.props;
        handleChange(this.state.tempColor);
    };

    render() {
        const {mod, tempColor} = this.state;
        const {value, handleChange} = this.props;
        const ColorValueInput = mod.value === RGB ? RGBInput : HEXInput;

        return (
            <div className="color-input">
                <div className="color-input__controls">
                    <DropdownSelect
                        options={colorOptions}
                        selectedValue={mod}
                        renderLabel={val => val.title}
                        onChange={this.changeMod}
                        styles={{width: '86px', height: '40px'}}
                        variant={'outline'}
                    >
                        {option => option.title}
                    </DropdownSelect>
                    <ColorValueInput value={value} handleChange={handleChange}/>
                    <input
                        className="color-input__swatch"
                        type="color"
                        value={swatchColor(tempColor)}
                        onChange={this.handleColorChange}
                        onBlur={this.handleColorBlur}
                        aria-label="Choose color"
                    />
                </div>
            </div>
        );
    }
}

ColorInput.propTypes = {
    value: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

class HEXInput extends Component {
    validate = (value) => {
        const isValid = /^#(\d|[A-F]){6}$/i.test(value);
        if (!isValid) {
            throw new Error('Wrong Format');
        }
    };

    render() {
        const {handleChange, value} = this.props;
        return (
            <Input
                className="color-input__hex"
                validate={this.validate}
                onChange={handleChange}
                defaultValue={value}
            />
        );
    }
}

HEXInput.propTypes = {
    value: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

class RGBInput extends Component {
    constructor(props) {
        super(props);
        const {value} = props;
        const valueInRgb = parseColor(value);
        this.state = {
            r: valueInRgb.r,
            g: valueInRgb.g,
            b: valueInRgb.b,
        };
    }

    validate = (value) => {
        isPositiveInteger(value);
        const parsedValue = Number(value);
        if (parsedValue < 0 || parsedValue > 255) {
            throw new Error('Wrong Range');
        }
    };

    handleChange = color => (value) => {
        const {handleChange, value: prevValue} = this.props;
        const prevValueInRgb = parseColor(prevValue);
        const parsedValue = Number(value);
        prevValueInRgb[color] = parsedValue;
        const valueInHex = rgbToHex(prevValueInRgb.r, prevValueInRgb.g, prevValueInRgb.b);
        handleChange(valueInHex);
    };

    render() {
        const {r, g, b} = this.state;
        return (
            <div className="color-input__rgb">

                <Input
                    className="color-input__channel"
                    validate={this.validate}
                    maxLength={3}
                    onChange={(e) => this.handleChange('r')(e.target.value)}
                    defaultValue={r}
                />

                <Input
                    className="color-input__channel"
                    validate={this.validate}
                    maxLength={3}
                    onChange={(e) => this.handleChange('g')(e.target.value)}
                    defaultValue={g}
                />

                <Input
                    className="color-input__channel"
                    validate={this.validate}
                    maxLength={3}
                    onChange={(e) => this.handleChange('b')(e.target.value)}
                    defaultValue={b}
                />

            </div>
        );
    }
}

RGBInput.propTypes = {
    value: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default ColorInput;



// WEBPACK FOOTER //
// ./src/components/ColorInput.jsx